import {store} from '../app/store';
import {setSubscriptionsAvailable} from '../features/app/appSlice';
import {axiosInstance} from './axios/AxiosInstance';

export const getSubscriptionsList = () => {
  axiosInstance
    .get(`/auth/subscriptions?Product=pilot`)
    .then(res => {
      store.dispatch(setSubscriptionsAvailable(res?.data?.Subscriptions));
    })
    .catch(err => console.log('Error getting subscriptions', err));
};
